// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { DxWidgetUtils, IconConstants, Utils } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// constant imports
import { WorkflowEditorActionConstants } from '../../../shared-workflow-module/_constants/workflow-editor-action-constants';

@Component({
    selector: 'app-workflow-step-reverse-or-delete',
    templateUrl: './workflow-step-reverse-or-delete.component.html',
    styleUrls: ['./workflow-step-reverse-or-delete.component.scss']
})
export class WorkflowStepReverseOrDeleteComponent implements OnInit {
    @ViewChild('reverseFromWorkflowEditorPopup', { static: false })
    reverseFromWorkflowEditorPopup: DxPopupComponent;

    @Input() action: string;

    @Output() onClose = new EventEmitter<void>();
    @Output() onDeniedReturnToCAM = new EventEmitter<void>();
    @Output() onDeniedSendToAAP = new EventEmitter<void>();
    @Output() onCompleteWorkflow = new EventEmitter<void>();

    visible = false;
    title: string;

    reverseActions: Array<any> = [];
    selectedReverseAction: string;

    iconCancel = IconConstants.CANCEL;
    iconCheck = IconConstants.CHECK;

    ngOnInit() {
        this.title = `${Utils.getTitleCase(this.action)} Bill`;

        this.reverseActions = [
            {
                action: WorkflowEditorActionConstants.REVERSE_OR_DELETE_RETURN_TO_CAM,
                text: 'Denied - Return to CAM'
            },
            {
                action: WorkflowEditorActionConstants.REVERSE_OR_DELETE_SEND_TO_AAP,
                text: 'Denied - Return to AAP'
            },
            {
                action: WorkflowEditorActionConstants.COMPLETE_WORKFLOW,
                text: 'Complete the Workflow'
            }
        ];
        this.selectedReverseAction = WorkflowEditorActionConstants.REVERSE_OR_DELETE_RETURN_TO_CAM;

        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        DxWidgetUtils.instantRepaint(this.reverseFromWorkflowEditorPopup);
    }

    onPopupClose(): void {
        this.closeActionBillFromWorkflowEditor();
    }

    onOkClick(): void {
        if (
            Utils.equalsIgnoreCase(
                this.selectedReverseAction,
                WorkflowEditorActionConstants.REVERSE_OR_DELETE_RETURN_TO_CAM
            )
        ) {
            this.onDeniedReturnToCAM.emit();
        } else if (
            Utils.equalsIgnoreCase(
                this.selectedReverseAction,
                WorkflowEditorActionConstants.REVERSE_OR_DELETE_SEND_TO_AAP
            )
        ) {
            this.onDeniedSendToAAP.emit();
        } else if (
            Utils.equalsIgnoreCase(this.selectedReverseAction, WorkflowEditorActionConstants.COMPLETE_WORKFLOW)
        ) {
            this.onCompleteWorkflow.emit();
        }

        this.closeActionBillFromWorkflowEditor();
    }

    onCancelClick(): void {
        this.closeActionBillFromWorkflowEditor();
    }

    private closeActionBillFromWorkflowEditor(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
